import { render, staticRenderFns } from "./recipe-cna-start.vue?vue&type=template&id=26ad997a&scoped=true&"
import script from "./recipe-cna-start.vue?vue&type=script&lang=js&"
export * from "./recipe-cna-start.vue?vue&type=script&lang=js&"
import style0 from "./recipe-cna-start.vue?vue&type=style&index=0&id=26ad997a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ad997a",
  null
  
)

export default component.exports